import { render, staticRenderFns } from "./ManagePackage.vue?vue&type=template&id=15d4a5e8&scoped=true&"
import script from "./ManagePackage.vue?vue&type=script&lang=js&"
export * from "./ManagePackage.vue?vue&type=script&lang=js&"
import style0 from "./ManagePackage.vue?vue&type=style&index=0&id=15d4a5e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d4a5e8",
  null
  
)

export default component.exports